import {SelectButton} from './select-button/select-button';

export enum InsuranceCompany {
  NOTHING = 'NOTHING',
  IA = 'IA',
  EMMA = 'EMMA',
  UV = 'UV',
  EMPIRE = 'EMPIRE',
  SUNLIFE = 'SUNLIFE',
  BENEVA = 'BENEVA',
  DESJARDINS = 'DESJARDINS',
  ASSOMPTION_VIE = 'ASSOMPTION_VIE',
  MANUVIE = 'MANUVIE',
  HUMANIA = 'HUMANIA',
}

const INSURANCE_COMPANY_SELECT_BUTTONS_FR: SelectButton<InsuranceCompany>[] = [
  {label: 'iA', value: InsuranceCompany.IA},
  {label: 'Emma', value: InsuranceCompany.EMMA},
  {label: 'UV', value: InsuranceCompany.UV},
  {label: 'Empire', value: InsuranceCompany.EMPIRE},
  {label: 'Sunlife', value: InsuranceCompany.SUNLIFE},
  {label: 'Beneva', value: InsuranceCompany.BENEVA},
  {label: 'Desjardins', value: InsuranceCompany.DESJARDINS},
  {label: 'Assomption Vie', value: InsuranceCompany.ASSOMPTION_VIE},
  {label: 'Manuvie', value: InsuranceCompany.MANUVIE},
  {label: 'Humania', value: InsuranceCompany.HUMANIA},
];

const INSURANCE_COMPANY_SELECT_BUTTONS_EN: SelectButton<InsuranceCompany>[] = [
  {label: 'iA', value: InsuranceCompany.IA},
  {label: 'Emma', value: InsuranceCompany.EMMA},
  {label: 'UV', value: InsuranceCompany.UV},
  {label: 'Empire', value: InsuranceCompany.EMPIRE},
  {label: 'Sunlife', value: InsuranceCompany.SUNLIFE},
  {label: 'Beneva', value: InsuranceCompany.BENEVA},
  {label: 'Desjardins', value: InsuranceCompany.DESJARDINS},
  {label: 'Assomption Life', value: InsuranceCompany.ASSOMPTION_VIE},
  {label: 'Manuvie', value: InsuranceCompany.MANUVIE},
  {label: 'Humania', value: InsuranceCompany.HUMANIA},
];

export const INSURANCE_COMPANY_SELECT_BUTTONS = {
  en: INSURANCE_COMPANY_SELECT_BUTTONS_EN,
  fr: INSURANCE_COMPANY_SELECT_BUTTONS_FR,
};
